import React from "react";
import Button from "react-bootstrap/Button";
import { useTerms } from "../contexts/TermsContext";
import { wwwUrl } from "../config/environment";

const TermsBanner = () => {
    const { needsAcceptance, dismissed, reopen } = useTerms();
    if (!needsAcceptance || !dismissed) return null;

    return (
        <div
            style={{
                background: "#fff3cd",
                color: "#664d03",
                padding: "0.5rem 1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ffe69c",
            }}
        >
            <span>
                Please review and accept our updated{" "}
                <a href={wwwUrl("/terms")} target="_blank" rel="noopener noreferrer">Terms</a>
                {" "}and{" "}
                <a href={wwwUrl("/privacy")} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </span>
            <Button size="sm" variant="warning" onClick={reopen}>
                Review &amp; accept
            </Button>
        </div>
    );
};

export default TermsBanner;
